import { useMutation, useQueryClient } from '@tanstack/react-query';

import { GET_CUSTOMERS_INFO_KEY } from './useGetCustomersInfo';
import { GET_CUSTOMERS_PAGINATED_KEY } from './useGetPaginatedCustomers';

import CustomerService, { CreateCustomerDto } from '@/services/CustomerService';

export function useCreateCustomer() {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation({
    mutationFn: (createCustomerDto: CreateCustomerDto) =>
      CustomerService.create(createCustomerDto),
    onSuccess: async () => {
      queryClient.invalidateQueries({
        queryKey: GET_CUSTOMERS_PAGINATED_KEY(),
      });

      queryClient.invalidateQueries({ queryKey: GET_CUSTOMERS_INFO_KEY });
    },
  });

  return {
    createCustomer: mutateAsync,
    isLoading: isPending,
  };
}
